export default {
  helloWorld: 'Ciao mondo!',
  routes: {
    pathPrefix: 'it',
    basePath: 'assicurazione-auto/calcolatore-premi',
    motorbikeBasePath: 'assicurazione-moto/calcolatore-premi',
    insuranceRequest: '',
    agent: 'agent',
    productSelect: 'premio',
    options: 'modifica-coperture',
    vehicleSelect: 'ricerca-auto',
    vehicleSelectComfort: 'comfort',
    vehicleSelectVehicleNumber: 'certificato-di-omologazione',
    vehicleSelected: 'veicolo-selezionato',
    vehicleData: 'dati-auto',
    owner: 'proprietario',
    personalData: 'dati-personali',
    checkout: 'verifica-dati',
    offer: 'richiesta-offerta',
    referral: 'referral',
    renewal: 'renewal',
    confirmation: 'conferma',
    infoLater: 'info-in-seguito',
    finish: 'completo',
    declined: 'rifiuto',
    rejected: 'elaborazione',
    offerExpired: 'scaduto',
    error: 'errore',
    maintenance: 'manutenzione',
    playground: 'playground',
    offerten_vorschlag: 'proposta_offerta',
  },
  errors: {
    graphqlQueryBase: 'Si è verificato un errore. Riprovare.',
    paper: 'in formato cartaceo',
    electronic: 'elettronico',
    vehicleNotFound: 'Veicolo non trovato. Verificare i dati inseriti o usare la ricerca veicolo.',
    technicalError: 'Si è verificato un errore tecnico. Riprovare.',
    technicalErrorLater: "Si è verificato un errore tecnico che richiederà un po' di tempo per essere risolto. Riprovare a eseguire il calcolo più tardi.",
    maintenance: 'Il sistema è attualmente in manutenzione. Riprovare a eseguire il calcolo più tardi.',
    declined: "Al momento attuale non possiamo purtroppo offrirle un'assicurazione per la sua auto.",
  },
  basics: {
    age: 'Età',
    plz: 'NPA',
    gender: 'Appellativo',
    genderFemale: 'Signora',
    genderMale: 'Signor',
    genderCompany: 'Azienda',
    firstName: 'Nome',
    lastName: 'Cognome',
    street: 'Via',
    houseNumber: 'Numero civico',
    city: 'Domicilio',
    email: 'E-mail',
    phone: 'Numero di telefono',
    dateOfBirth: 'Data di nascita',
    licence: 'Licenza di condurre',
    nationality: 'Nazionalità',
    swiss: 'Svizzera',
    others: 'Altra',
    chooseOption: 'Selezionare',
    noResultsOption: 'Nessun risultato',
    unknownOption: 'Non so',
    selectProduct: 'Seleziona prodotto',
    customizeCoverage: 'Modifica coperture',
    vehicle: 'Veicolo',
    ovner: 'Proprietario',
    enterContract: 'Stipula',
    continue: 'avanti',
    back: 'indietro',
    reset: 'Ignora dati',
    yes: 'Sì',
    no: 'No',
    notWanted: 'non desiderato',
    datePlaceholder: 'GG.MM.AAAA',
    yearPlaceholder: 'AAAA',
    company: 'Nome azienda',
    uid: 'Partita IVA',
    industry: 'Settore',
    vehicleType: 'Il pericolo è',
    flexDrive: 'FlexDrive',
    basisDrive: 'BasisDrive',
  },

  start: {
    head: {
      h1: 'La sua nuova assicurazione auto',
      h3: 'Calcoli il premio della nuova assicurazione per il suo veicolo',
      p: 'Prodotti top, interamente digitali, ma con assistenza personalizzata: questa è Simpego.',
      list: {
        car: 'Autovettura',
        van: 'Furgone',
        vanRegisteredAsCar: 'Veicoli aziendali',
        motorbike: 'Moto',
      },
    },
    form: {
      personal: {
        h3: 'Dati personali',
        age1: 'Ho',
        age2: 'anni.',
        plz1: 'Il mio NPA è',
        otherNationality: 'Altra nazionalità',
        customerTypePerson: 'Cliente privato',
        customerTypeCompany: 'Cliente aziendale',
        companyZip: "NPA dell'azienda",
        industry: 'Settore aziendale',
        industries: {
          industry1: 'Commercio, finanza, consulenza, immobiliare, IT',
          industry2: 'Alberghiero e ristorazione, turismo e viaggi, tempo libero',
          industry3: 'Edilizia, officine, metalmeccanica',
          industry4: 'Produzione, smaltimento, pulizia',
          industry5: 'Poste, corrieri, consegne, trasporti',
          industry6: 'Trasporto marittimo e aereo',
          industry7: 'Noleggio di veicoli',
          industry8: 'Assistenza sanitaria',
          industry9: 'Musica, multimedia, case editrici, TV, pubblicità',
          industry10: 'Enti pubblici, musei, chiese, associazioni',
          industry11: 'Agricoltura, gestione idrica, energia, chimica',
          industry12: 'Organizzazioni di soccorso',
          industry13: 'altro',
        },
        ageOrYear: 'Età/anno di nascita',
        zip: 'NPA',
      },
      car: {
        h3: 'Dati del veicolo',
        searchmode1: 'Ricerca veicolo',
        searchmode2: 'Inserimento certificato di omologazione',
        initialRegistrationYear: 'Prima immatricolazione (anno)',
        brand: 'Il marchio del mio veicolo è',
        model: 'Il modello è',
        fuelType: 'È alimentato a (carburante)',
        powerRange: 'La potenza è di (CV)',
        typeCertificateNumber: 'Il numero del certificato di omologazione è',
        typeCertificateNumber_placeholder: 'Cifra 24 della licenza di circolazione',
        vehicleSearchError: 'La ricerca non ha prodotto risultati.',
      },
      startOfInsurance: {
        h3: 'Inizio assicurazione',
        startOfInsurance: "L'inizio desiderato per l'assicurazione è",
      },
      sendButton: 'Visualizza premio',
    },
  },
  insurancerequest: {
    annoPrice: '/anno',
    from: 'da',
    footerBackText: 'ricalcola',
    declinedHeadline: 'Impossibile calcolare il prezzo. Motivo:',
  },
  customizeCoverage: {
    form: {
      deductible: {
        h3: 'Responsabilità civile',
        h3Hint: "L'assicurazione di responsabilità civile obbligatoria copre i danni a beni materiali di terzi o persone, causati con il suo veicolo da lei in qualità di conducente o da una persona della quale lei è responsabile. E precisamente nelle situazioni seguenti:<br><br> - con l'utilizzo del veicolo;<br> - in caso di incidenti stradali causati dal veicolo quando non è in uso;<br> - in seguito all’/assistenza prestata in incidenti in cui il veicolo è coinvolto;<br> - nell'entrare e nell'uscire dal veicolo, nell'apertura e chiusura di componenti mobili del veicolo e nel collegare o scollegare un rimorchio o un altro veicolo.<br><br>Simpego copre le pretese di risarcimento giustificate e difende da quelle ingiustificate per la persona assicurata.. Le prestazioni sono limitate a CHF 100 milioni per sinistro, inclusi eventuali interessi sul debito, spese legali e spese processuali. Franchigie per conducenti di età inferiore a 25 anni: M più CHF 1\´500, L più CHF 1\´200 e XL più CHF 1\´000.",
        customizeCoverage: {
          label: 'Franchigia in CHF',
          infoText: 'Selezioni la sua franchigia. In caso di sinistro questo importo sarà a suo carico.',
          inputHint: 'Indichi un valore compreso fra CHF {min} e {max}',
        },
        customizeCoverage25: {
          label: 'Franchigia per conducenti non dichiarati di età inferiore ai 25 anni',
          infoText: 'Questa franchigia non si applica nel caso in cui i conducenti di età inferiore ai 25 anni siano stati dichiarati o sia lei ad avere meno di 25 anni.',
          value: '+ CHF {value}',
        },
        fieldName: 'Franchigia',
      },
      comprehensive: {
        h3: 'Casco',
        comprehensiveOptions: {
          label: 'Seleziona casco',
          infoText: "Assicurazione casco totale (casco parziale e casco collisione)<br><br> Oltre a tutte le prestazioni dell'assicurazione casco parziale, sono inclusi i danni causati da un evento esterno improvviso, violento, meccanico o involontario, ad esempio un urto, una collisione, una caduta o un ribaltamento.<br><br> Assicurazione casco parziale<br> Copre i danni provocati da incendi, eventi naturali, slavine, furti, collisioni con animali, danni da martore, rottura di finestrini (rottura vetri Basis), atti vandalici e danni causati dalla caduta di veicoli aerei e spaziali o parte degli stessi nonché da atterraggi di emergenza.",
        },
        partially_comprehensive: {
          label: 'Franchigia casco parziale in CHF',
          infoText: 'Selezioni la sua franchigia. In caso di sinistro questo importo sarà a suo carico.',
          inputHint: 'Indichi un valore compreso fra CHF {min} e {max}',
        },
        fully_comprehensive: {
          label: 'Franchigia collisione in CHF',
          infoText: 'Selezioni la sua franchigia. In caso di sinistro questo importo sarà a suo carico.',
          inputHint: 'Indichi un valore compreso fra CHF {min} e {max}',
        },
        deductible_under_25: {
          label: 'Franchigia collisione per conducenti non dichiarati di età inferiore ai 25 anni',
          infoText: 'Questa franchigia non si applica nel caso in cui i conducenti di età inferiore ai 25 anni siano stati dichiarati o sia lei ad avere meno di 25 anni.',
          value: '+ CHF {value}',
        },
      },
      comprehensiveOptions: {
        h3: 'Integrazioni casco',
        park_damage: {
          label: 'Copertura danni di parcheggio',
          infoText: "Danni di parcheggio Basis<br> I danni al veicolo parcheggiato causati da terzi ignoti sono assicurati tenendo conto della franchigia di CHF 2\´000 per sinistro. <br><br> Danni di parcheggio Plus<br> I danni al veicolo parcheggiato causati da terzi ignoti sono assicurati tenendo conto della franchigia selezionata e senza limitazioni d'importo. <br><br> Sono assicurati un massimo di 2 sinistri per ogni anno civile.",
        },
        park_damage_deductible: {
          label: 'Franchigia danni di parcheggio in CHF',
          infoText: "Selezioni la sua franchigia. In caso di sinistro questo importo sarà a suo carico. La franchigia per la copertura dei danni di parcheggio deve essere inferiore alla franchigia per l'assicurazione casco collisione.",
          inputHint: 'Indichi un valore compreso fra CHF {min} e {max}',
        },
        free_garage: {
          label: 'Modello di riparazione in caso di sinistro',
          infoText: "Modello di riparazione officina partner<br><br>Lei si impegna a denunciarci i danni casco prima della riparazione e a far eseguire la riparazione in un’officina <a href='https://blog.simpego.ch/garage-convenzionato/' target='blank'>partner </a> di simpego. In compenso beneficia di premi casco più vantaggiosi. Se in caso di sinistro non rispetta l’accordo, il contratto passa al modello di riparazione «libera scelta dell’officina» e occorre pagare la differenza di premio per un massimo di un anno.<br><br><br>Modello di riparazione libera scelta dell’officina<br><br>Lei può scegliere liberamente l’officina di riparazione.",
          options: {
            true: 'Libera scelta dell’officina',
            false: 'Officina partner',
          },
        },
        glass: {
          label: 'Vetro Plus (vetri piccoli)',
          infoText: 'Nell’ambito dell’assicurazione casco parziale sono assicurati solo danni da rottura ai finestrini anteriori, laterali, posteriori e al tetto scorrevole in vetro. Sono inoltre assicurati anche i materiali che fungono da sostitutivi del vetro (rottura vetri Basis).<br><br>Rottura vetri Plus (vetri piccoli)<br>Sono assicurati anche danni da rottura per tutti gli altri componenti in vetro del veicolo (inclusi i piccoli vetri come quelli dei fari, degli indicatori di direzione ecc.). Sono assicurati anche i materiali sostitutivi del vetro. Sono inoltre assicurati lampadine e diodi luminosi (LED) se vengono distrutti con la rottura dei vetri.',
        },
        personal_effects_coverage: {
          label: 'Valore degli effetti personali trasportati in CHF',
          infoText: "Sono assicurati gli effetti personali dei passeggeri che vengono rubati dal veicolo chiuso o insieme allo stesso oppure che vengono danneggiati in seguito a un sinistro assicurato subito dal veicolo. Simpego copre la riparazione fino alla somma assicurata concordata o l'importo per il nuovo acquisto in caso di danno totale.",
        },
        suspension: {
          label: 'In caso di sospensione',
          text: 'non vi sarà un rimborso dei premi',
          infoText: 'In caso di deposito temporaneo delle targhe, il premio non viene rimborsato in modo proporzionale.',
        },
        protective_clothing: {
          label: 'Abbigliamento di protezione (compreso quello del passeggero al valore a nuovo)',
          infoText: " In caso di sinistro casco assicurato, l'abbigliamento di protezione del conducente e del passeggero sono assicurati al valore a nuovo. Rientrano nell’abbigliamento di protezione caschi, occhiali di protezione, guanti, stivali, protezioni e combinazioni di indumenti e protezioni nonché tute protettive.",
          fieldName: 'Abbigliamento di protezione',
        },
      },
      passenger_accident: {
        label: 'Assicurazione infortuni',
        labelHint: 'Tutti i passeggeri, prestazioni per persona, spese di cura assicurate',
        infoText: "La nostra assicurazione infortuni copre lei e tutti i passeggeri dalle conseguenze economiche di un incidente avuto con il veicolo assicurato.<br><br> Per tutte le varianti si applica quanto segue: Spese di cura - reparto privato. Vi sono differenze di copertura per quanto riguarda l'indennità giornaliera, il capitale d'invalidità e il capitale di decesso.<br><br> Standard: indennità giornaliera CHF {DexCarM_daily_compensation}, invalidità CHF {DexCarM_disability_capital}, decesso CHF {DexCarM_death_benefit}<br><br> Basis: indennità giornaliera CHF {DexCarL_daily_compensation}, invalidità CHF {DexCarL_disability_capital}, decesso CHF {DexCarL_death_benefit}<br><br> Plus: indennità giornaliera CHF {DexCarXl_daily_compensation}, invalidità CHF {DexCarXl_disability_capital}, decesso CHF {DexCarXl_death_benefit}<br><br> Tutte le prestazioni sono valide per persona. Le prestazioni vengono pagate subito, ossia già prima dell'accertamento della responsabilità. Le prestazioni per invalidità e decesso vengono corrisposte in aggiunta alle prestazioni dell'assicurazione di responsabilità civile e di altre assicurazioni infortuni.<br><br> Se un animale domestico trasportato subisce una lesione nel veicolo, copriamo le spese di cura fino a CHF 2\´500 per animale e al massimo fino a CHF 5\´000 per sinistro.",
      },
      negligence: {
        label: 'Colpa grave',
        infoText: "Le offriamo protezione assicurativa completa anche se l'incidente è stato causato da colpa grave, ad esempio se si è distratto per qualche istante e non ha visto un semaforo rosso. In questi casi rinunciamo al nostro diritto di rivalsa o riduzione. Questo non si applica, tuttavia, nel caso in cui l/idoneità alla guida sia stata compromessa dall'uso di alcol o droghe o dall'abuso di farmaci.",
      },
      assistance24: {
        label: 'Assistenza 24 ore su 24',
        infoText: "Le nostre prestazioni le forniscono la necessaria sicurezza in caso di guasti o incidenti: Ci facciamo carico dell'organizzazione e dei costi in loco per guasti e incidenti e garantiamo la sua mobilità.<br><br> Con Assistance Basis e Plus sono assicurati anche i seguenti servizi di assistenza:<br> soccorso stradale, recupero e rimorchio del veicolo fino alla più vicina officina di riparazione idonea (Basis), trasporto del veicolo fino a un'officina a scelta (Plus), costi di pernottamento, costi di viaggio, trasporto del veicolo, garanzia della mobilità (con veicolo a noleggio/sostitutivo, mezzi pubblici, taxi) fino a CHF 1\´500 (Basis) o CHF 4\´000 (Plus), servizio di avviso.",
      },
      daily_termination: {
        label: 'Diritto di recesso giornaliero',
      },
      payment_frequency: {
        label: 'Metodo di pagamento',
        infoText: 'Può pagare il premio anticipatamente su base semestrale o annuale. Per i pagamenti infrannuali viene applicato un supplemento.',
      },
      payment_type: {
        label: 'Modalità di pagamento',
        invoice: 'mediante fattura',
        creditCard: 'Carta di credito',
      },
      document_delivery: {
        label: 'Tipo di consegna dei documenti',
        infoText: 'Tutti i documenti le vengono consegnati in formato elettronico.',
        email: 'formato elettronico tramite e-mail',
      },
      taxesTotal: {
        label: 'Contributi obbligatori',
        infoText: "I contributi obbligatori sono così composti: <br> - tassa di bollo 5% del premio di responsabilità civile e casco<br> - contributo LCStr CHF 4,20 (ai sensi dell'art. 74 e 76a LCStr, sul premio di responsabilità civile)<br> - contributo alla prevenzione degli incidenti 0,75% del premio di responsabilità civile",
      },
      priceTotal: {
        label: 'Premio annuale totale',
        infoText: 'Il suo premio in base al metodo di pagamento scelto incluse tutte le tasse e contributi',
      },
      errors: {
        vehicleLeasing: 'I veicoli in leasing necessitano di casco collisione.',
      },
    },
    customized: 'personalizzato',
    comprehensives: {
      notWanted: 'non desiderato',
      liability: 'Responsabilità civile',
      partially_comprehensive: 'Casco parziale',
      fully_comprehensive: 'Casco totale',
    },
  },
  vehicleSelect: {
    basics: {
      initialRegistrationYear: 'Prima immatricolazione',
      chooseCar: {
        text: 'Seleziona veicolo',
        infoText: "Selezioni il suo veicolo nel modo più preciso possibile. Minime differenze nel tipo di veicolo non rappresentano in genere un problema e non influiscono sul premio assicurativo. Il servizio della circolazione ci comunica i dati esatti del suo veicolo al momento dell'immatricolazione. In caso di differenze importanti, la contatteremo.",
      },
    },
    comfort: {
      brand: 'Marchio',
      model: 'Modello',
      fuelType: 'Alimentazione',
      vehicleCategory: 'Categoria',
      vehiclePower: 'CV',
      transmission: 'Cambio',
    },
    vehicleNumber: {
      typeCertificateNumber: {
        label: 'Certificato-di-omologazione',
        placeholder: 'Cifra 24 della licenza di circolazione',
      },
    },
    selected: {
      headline: {
        text: 'Il veicolo da lei scelto',
        infoText: "Selezioni il suo veicolo nel modo più preciso possibile. Minime differenze nel tipo di veicolo non rappresentano in genere un problema e non influiscono sul premio assicurativo. Il servizio della circolazione ci comunica i dati esatti del suo veicolo al momento dell'immatricolazione. In caso di differenze importanti, la contatteremo.",
      },
      btn1: 'Seleziona nuovo veicolo',
      btn2: 'Conferma veicolo',
    },
  },
  vehicleData: {
    headline: 'Dati del veicolo',
    ownedSince: {
      label: 'In possesso dal',
      infoText: 'Indichi da quanto tempo possiede il veicolo.',
    },
    canton: {
      label: "Cantone d'immatricolazione",
      infoText: 'Indichi il cantone in cui il veicolo deve essere immatricolato.',
    },
    businessUsage: {
      label: 'Il veicolo verrà usato per viaggi di lavoro?',
      infoPerson: 'Usa il veicolo anche per conto del suo datore di lavoro? Ad es. commerciale esterno',
      infoCompany: 'Usa il veicolo anche per lavoro?',
    },
    transport: {
      label: 'Il veicolo viene usato per offrire un servizio commerciale o professionale di trasporto di persone o merci?',
      infoText: 'Si considera utilizzo commerciale o professionale quando è finalizzato alla realizzazione di un profitto attraverso il trasporto di merci o persone.',
    },
    leasing: {
      label: 'Leasing',
      infoText: "Indichi se il veicolo è in leasing. Tenga presente che per un veicolo in leasing è di norma necessaria un'assicurazione casco totale.",
    },
    startOfInsurance: {
      label: 'Inizio assicurazione desiderato',
      infoText: "Selezioni qui da quando desidera che abbia inizio l'assicurazione. La sua assicurazione avrà inizio in quel momento.",
    },
    errors: {
      vehicleLeasing: 'I veicoli in leasing necessitano di casco collisione. Abbiamo adeguato di conseguenza la sua copertura.',
    },
    vehicleRegistrationType: {
      label: 'Il veicolo è immatricolato come',
      info: 'Indichi se il veicolo viene immatricolato come furgone o come autovettura.',
      car: 'Autovettura',
      van: 'Furgone',
      carOrVan: 'Automobili / furgoni',
      motorbike: 'Moto',

    },
    truckExtEquipment: {
      label: 'Ha delle sovrastrutture per questo veicolo?',
      info: "Si considerano sovrastrutture quelle montate fisse sui furgoni (ad es. cassoni, ponti, ribaltabili ecc.) destinate esclusivamente all'utilizzo con il veicolo assicurato e non incluse nel prezzo di listino dello stesso. Non sono considerati sovrastrutture gli oggetti trasportati all'interno del veicolo.",
      inputHint: 'Inserisca un valore compreso fra CHF 0 e 999\´999',
      fieldName: 'Valore delle sovrastrutture',
    },
    truckIntEquipment: {
      label: 'Il veicolo ha delle installazioni speciali?',
      info: "Si considerano installazioni gli allestimenti montati fissi sui furgoni (ad es. per veicoli di servizio, per la manutenzione della casa ecc.) destinati esclusivamente all'utilizzo con il veicolo assicurato e non inclusi nel prezzo di listino dello stesso. Non sono considerate installazioni gli oggetti trasportati all'interno del veicolo.",
      inputHint: 'Inserisca un valore compreso fra CHF 0 e 999\´999',
      fieldName: 'Valore delle installazioni',
    },
  },
  owner: {
    headline: 'Dati del proprietario',
    nationality: {
      label: 'Nazionalità',
      infoText: 'Si accerti di identificarsi con la stessa nazionalità presso il servizio della circolazione.',
    },
    residencePermit: {
      label: 'Permesso di soggiorno',
      infoText: 'Indichi il tipo del suo permesso di soggiorno.',
      B1: 'B',
      C: 'C',
      L: 'altro',
    },
    driverLicenceSinceYear: {
      label: 'Licenza di condurre dal (anno)',
      infoText: "Indichi da quando può guidare un'autovettura sulle strade. È necessaria un'età minima di 17 anni.",
    },
    isKeeperMainDriver: {
      label: 'Il proprietario del veicolo è il conducente più frequente?',
      infoText: "Indichi se un'altra persona diversa dal proprietario del veicolo è l'utilizzatore più frequente.",
    },
    youngDriver: {
      label: 'Il veicolo è usato da persone di età inferiore ai 25 anni?',
      infoText: 'Indichi se il veicolo è usato da persone di età inferiore ai 25 anni.',
      youngDriverOptions: {
        male: 'sì, maschi',
        female: 'sì, femmine',
        both: 'sì, entrambi',
      },
    },
    driverLicenceWithdrawal: {
      label: 'Negli ultimi 5 anni le è stata ritirata la licenza di condurre per più di 3 mesi oppure le è stata revocata o rifiutata una polizza?',
      labelMainDriver: 'Negli ultimi 5 anni a lei o al conducente più frequente è stata ritirata la licenza di condurre per più di 3 mesi oppure è stata revocata o rifiutata una polizza?',
      infoPerson: "Indichi se negli ultimi 5 anni le è stata ritirata la licenza di condurre, se un'assicurazione ha rifiutato la sua richiesta, se le è stato revocato un contratto di assicurazione o se la prosecuzione dello stesso è stata vincolata a un inasprimento delle condizioni.",
      infoCompany: "Indichi se negli ultimi 5 anni un'assicurazione le ha rifiutato una richiesta, se le è stato revocato un contratto di assicurazione o se la prosecuzione dello stesso è stata vincolata a un inasprimento delle condizioni.",
      infoMainDriver: "Indichi se negli ultimi 5 anni a lei o al conducente più frequente è stata ritirata la licenza di condurre, se un'assicurazione ha rifiutato la sua richiesta, se le è stato revocato un contratto di assicurazione o se la prosecuzione dello stesso è stata vincolata a un inasprimento delle condizioni.",
    },
    policyCancelledOrRejected: {
      label: 'Negli ultimi 5 anni le è stata revocata o rifiutata una polizza?',
    },
    tooManyAccidents: {
      label: 'Ha avuto 3 o più sinistri negli ultimi 3 anni?',
      labelMainDriver: 'Lei o il conducente più frequente avete avuto 3 o più sinistri negli ultimi 3 anni?',
      infoText: 'Dichiari tutti i sinistri degli ultimi 3 anni per i quali la sua assicurazione ha corrisposto una prestazione. Ad esempio, danni da responsabilità civile, danni da collisione, danni di parcheggio, danni da martore, danni a cristalli ecc.',
      infoMainDriver: 'Dichiari tutti i sinistri degli ultimi 3 anni per i quali la sua assicurazione o quella del conducente più frequente ha corrisposto una prestazione. Ad esempio, danni da responsabilità civile, danni da collisione, danni di parcheggio, danni da martore, danni a cristalli ecc.',
    },
  },
  personalData: {
    headline: {
      agent: "Dati dell'intermediario",
      person: 'Dati personali',
      personForAgent: 'Dati personali del cliente',
    },
    agentEmail: {
      label: "E-mail dell'intermediario",
    },
    customerDocuments: {
      label: 'Gestione dei documenti del cliente',
      infoText: 'Scelga se i documenti dovranno essere inviati solo a lei o direttamente al cliente oppure al cliente con lei in copia.<br><br> Documenti interessati: <br> - Documenti contrattuali inclusivo fatture <br> - Documenti di rinnovo inclusivo fatture',
      toAgent: "solo all'intermediario",
      toCustomer: 'solo al cliente',
      toCustomerAndAgent: 'al cliente con cc intermediario',
    },
    invoices: {
      label: 'Gestione delle fatture successive nel corso dell\'anno',
      infoText: "Scelga se i documenti dovranno essere inviati solo a lei o direttamente al cliente oppure al cliente con lei in copia. Documenti interessati: <br> - Fatture successive nel corso dell\'anno senza rinnovo. Il controllo dell'invio delle fatture successive durante l'anno viene utilizzato anche per controllare l'invio delle e-mail relative alle carte di credito (ad esempio, registrazione, addebito non possibile o informazioni su carte di credito scadute o non valide), motivo per cui per il tipo di pagamento con carta di credito viene selezionato “solo al cliente” e non può essere modificato.",
    },
    reminders: {
      label: 'Gestione degli documenti di recupero crediti',
      infoText: 'Scelga se i documenti dovranno essere inviati solo a lei o direttamente al cliente oppure al cliente con lei in copia. Documenti interessati: <br> - Friendly Reminder <br> - Sollecito di pagamento <br> - Promemoria (il promemoria viene sempre inviato anche direttamente al cliente per posta.)',
    },
    agentMailsDelivery: {
      label: 'Gestione delle e-mail',
      infoText: "Le e-mail inviate dal funnel di vendita online vengono inviate all'indirizzo e-mail dell'intermediario indicato, se è selezionato intermediario o cliente cc intermediario. <br> Se è selezionato \"cliente\", le e-mail vengono inviate solo al cliente. <br><br>Mail interessate:<br> - E-mail di offerta <br> - E-mail di conferma per l'arrivo della stipula<br> - Conferma dell'emissione del certificato di assicurazione<br> - Eventuali e-mail di follow-up",
      dispatchDocumentOptions: {
        option1: 'al cliente con cc intermediario',
        option2: "solo all'intermediario",
        option3: 'solo al cliente',
      },
      toAgent: "solo all'intermediario",
      toCustomer: 'solo al cliente',
      toCustomerAndAgent: 'al cliente con cc intermediario',
    },
    btn: 'Verifica dati',
    errors: {
      zipCode: 'Indichi un NPA valido.',
    },
    industry: {
      infoText: 'Indichi il suo settore come da iscrizione nel registro di commercio.',
    },
    emailInfoText: "Abbiamo bisogno del suo indirizzo per aprire un dossier cliente. Tutte le e-mail correlate a questa offerta (ad es. e-mail di offerta o di follow-up) o la conferma dell'arrivo della stipula dell'assicurazione (e-mail di stipula) le verranno inviate all'indirizzo e-mail precedentemente scelto, non al cliente. Tramite il campo 'Gestione dei documenti del cliente’ è possibile impostare a chi devono essere inviati i documenti dopo l'emissione della polizza.",
    warningAgentEmail: "Si prega di controllare l'inserimento. L'indirizzo e-mail del cliente non può coincidere con uno degli indirizzi e-mail dell'intermediario.",
    warningPhoneTracking: "Si prega di notare che ogni numero di cellulare può essere utilizzato solo per un contratto FlexDrive/BonusDrive attivo. È necessario un numero di cellulare separato per ogni contratto aggiuntivo.",
  },
  priceBox: {
    tariffOptions: {
      liabilityDeductible: 'Responsabilità civile <em>franchigia (CHF {deductible})</em>',
      partiallyComprehensiveDeductible: 'Casco parziale <em>franchigia (CHF {deductible})</em>',
      fullyComprehensiveDeductible: 'Casco collisione <em>franchigia (CHF {deductible})</em>',
      parkDamageDeductible: 'Danni di parcheggio <em>franchigia (CHF {deductible})</em>',
      protectiveClothing: 'Abbigliamento di protezione <em>(CHF {value})</em>',
      glass: 'Vetro Plus (vetri piccoli)',
      freeGarage: 'Modello di riparazione: <em>{free_garage}</em>',
      personalEffectsCoverage: 'Effetti personali trasportati (CHF {coverage})',
      parkDamage: 'Copertura danni di parcheggio <span class="{bundleClass}">{bundle}</span>',
      passengerAccident: 'Assicurazione infortuni <span class="{bundleClass}">{bundle}</span>',
      grossNegligence: 'Colpa grave',
      assistance24: 'Assistenza 24 ore su 24 <span class="{bundleClass}">{bundle}</span>',
      dailyTermination: 'Diritto di recesso giornaliero',
    },
    pricePerYear: '{price} /anno',
    pricePerKm: '{price} /km',
    maxPerYear: 'max. {price} CHF /anno',
    exactKm: ' preciso al chilometro ',
  },
  checkout: {
    headline: {
      h3: 'Riepilogo della sua offerta',
      text: 'Basta un solo clic e avrà una nuova assicurazione auto. Verifichi ancora una volta i dati immessi finora.',
    },
    summary: {
      basics: {
        headline: "Dati generali dell'assicurazione",
        pricePerYear: 'Anno',
        startOfInsurance: 'Assicurazione attiva da',
        endOfInsurance: 'Fine dell\'assicurazione',
        priceWithKmPremium: '{fix}/anno + {perKm}/km, max. {max}/anno',
        onlyKmPremium: '{perKm}/km, max. {max}/anno',
      },
      car: {
        headline: 'Dati del veicolo',
        registrationType: 'Tipo di immatricolazione',
        truckEquipmentLabel: 'Ulteriori sovrastrutture e installazioni',
      },
      payment: {
        headline: 'Informazioni di pagamento',
        billEmail: 'Fattura tramite e-mail',
        documentsEmail: 'formato elettronico tramite e-mail',
        creditCard: 'Carta di credito',
        monthly: 'mensile',
        yearly: 'annuale',
        half_yearly: 'semestrale',
        quarterly: 'trimestrale',
        billingModel: ' Modello di fatturazione ',
      },
      checkoutlegal_checkbox: {
        agbUrl: 'https://doc.simpego.ch/it/condizioni-generali/cg/',
        privacyUrl: 'https://www.simpego.ch/it/protezione-dei-dati',
        agent: {
          part1: 'Confermo che il cliente ha letto e accettato le',
          part2: 'condizioni generali di assicurazione (CGA)',
          part3: 'e le',
          part4: 'condizioni generali (CG)',
          part5: 'nonché la',
          part6: 'protezione dei dati',
          part7: "Confermo inoltre di essere autorizzato a stipulare questo contratto o di disporre di un apposito mandato firmato. Confermo anche di avere adempiuto all'obbligo di informare il cliente in conformità con l'art. 45 della LSA.",
        },
        person: {
          part1: 'Sì, vorrei stipulare un contratto di assicurazione online e confermo di avere letto e accettato le',
          part2: 'condizioni generali di assicurazione (CGA)',
          part3: 'e le',
          part4: 'condizioni generali (CG)',
          part5: 'nonché la',
          part6: 'protezione dei dati',
          part7: '.',
        },
      },
      btn: {
        signContact: 'Stipula contratto',
        requestProposal: 'Richiedi offerta',
      },
      consultationProtocol: {
        input: 'Upload del protocollo di consultazione o del mandato del cliente',
        tooltip: 'È possibile caricare qui il protocollo di consultazione o il mandato del cliente. Questo viene\n'
          + 'trasferito a simpego insieme alla richiesta di offerta e memorizzato con la rispettiva offerta.\n'
          + 'Se si calcolano più varianti di offerta, il documento caricato viene visualizzato per ogni offerta\n'
          + 'e si ha la possibilità di cancellarlo e caricarne uno nuovo',
        clear: 'Campo di input vuoto',
        errors: {
          size: 'La dimensione del documento non deve superare i 5 MB.',
          type: 'Purtroppo il caricamento del documento è andato male. I formati consentiti per il documento sono: pdf, jpeg, png.',
        },
      },
      tariffOptions: {
        liabilityDeductible: 'Franchigia responsabilità civile (CHF {deductible})',
        partiallyComprehensiveDeductible: 'Franchigia casco parziale (CHF {deductible})',
        fullyComprehensiveDeductible: 'Franchigia collisione (CHF {deductible})',
        parkDamageDeductible: 'Franchigia danni di parcheggio (CHF {deductible})',
        protectiveClothing: 'Abbigliamento di protezione (CHF {value})',
        glass: 'Vetro Plus (vetri piccoli)',
        freeGarage: 'Modello di riparazione: {free_garage}',
        personalEffectsCoverage: 'Effetti personali trasportati (CHF {coverage})',
        parkDamage: 'Copertura danni di parcheggio {bundle}',
        passengerAccident: 'Assicurazione infortuni {bundle}',
        grossNegligence: 'Colpa grave',
        assistance24: 'Assistenza 24 ore su 24 {bundle}',
        dailyTermination: 'Diritto di recesso giornaliero',
        suspension: 'In caso di sospensione non vi sarà un rimborso dei premi',
      },
    },
    errors: {
      applyContract: 'Si è verificato un errore.',
      requestProposal: 'Si è verificato un errore. Riprovare.',
    },
    specialConditions: {
      payPerKM: {
        title: 'Condizioni particolari: Car FlexDrive',
        conditions: [
          {
            text: 'In caso di contraddizioni fra le condizioni generali di assicurazione (CGA) valide per il contratto e queste condizioni particolari (CP) si applicano le condizioni particolari.',
          },
          {
            headline: "Che cos'è Car FlexDrive:",
            text: "Con FlexDrive una parte o l'intero premio del contratto di assicurazione è basato sul numero di chilometri che vengono percorsi con il veicolo assicurato. Per ogni chilometro è dovuto il premio stabilito nel contratto di assicurazione. L'eventuale premio fisso concordato è dovuto indipendentemente dai chilometri percorsi.",
          },
          {
            headline: 'Importo annuale massimo:',
            text: "Il premio annuale massimo dovuto (importo massimo) è stabilito nel contratto di assicurazione. Una volta raggiunto l'importo massimo, non verranno addebitati altri premi per il resto dell'anno assicurativo, a condizione che il contratto rimanga invariato.",
          },
          {
            headline: 'Pagamento del premio e conseguenze in caso di mancato pagamento:',
            text: "Una volta al mese viene effettuato un addebito sulla carta di credito memorizzata nell'app autoSense. Viene addebitato il premio per ogni chilometro percorso nel mese precedente e un dodicesimo dell'eventuale premio fisso. L'importo addebitato include già le tasse e i contributi obbligatori. Per ogni addebito, Simpego le invia un conteggio in formato elettronico. che contiene il numero di chilometri percorsi, il premio corrispondente e l'eventuale premio fisso. Se l'importo dovuto non può essere addebitato entro 30 giorni sulla carta di credito memorizzata nell'app autoSense, Simpego ha il diritto di richiedere immediatamente l'importo massimo stabilito nel contratto. Per la richiesta dell'importo massimo le viene inviata una fattura. Dall'importo massimo vengono sottratti i premi già pagati per questo anno assicurativo. Per la restante durata del contratto non viene addebitato alcun altro premio, a condizione che il contratto rimanga invariato.",
          },
          {
            headline: 'Richieste correlate a sinistri:',
            text: 'Per franchigie e richieste di restituzione avanzate in relazione a sinistri, le inviamo una fattura. Questi importi non vengono addebitati sulla carta di credito.',
          },
          {
            headline: "Condizione per l'utilizzo di Car FlexDrive:",
            text: "per l'utilizzo di FlexDrive l'utente si impegna per la durata del contratto a non rimuovere l'adattatore autoSense dal veicolo o a farlo soltanto in casi giustificati.",
          },
          {
            headline: 'Disconnect:',
            text: "se l'adattatore autoSense viene rimosso dal veicolo, si ha un cosiddetto Disconnect, che viene notificato da autoSense a Simpego, così come accade con il Connect non appena viene ricollegato l'adattatore. Se durante un Disconnect, quindi senza adattatore collegato, il veicolo viene spostato per più di 100 metri (differenza di chilometraggio del veicolo fra Disconnect e Connect), Simpego può richiedere all'utente una giustificazione scritta. Simpego si riserva inoltre il diritto di non proseguire più il conteggio al chilometro dopo un Disconnect. In tal caso sarà immediatamente dovuto l'importo massimo stabilito nel contratto. Dall'importo massimo vengono sottratti i premi già pagati per questo anno assicurativo. Per la restante durata del contratto non viene addebitato alcun altro premio, a condizione che il contratto rimanga invariato. Per la richiesta dell'importo massimo le viene inviata una fattura. Questi importi non vengono addebitati sulla carta di credito.",
          },
          {
            headline: 'Deposito delle targhe (sospensione):',
            text: 'I contratti di assicurazione FlexDrive che includono un premio fisso non variano nel caso in cui le targhe vengano depositate presso il servizio della circolazione, ma il veicolo assicurato resti in suo possesso. Il premio fisso è dovuto anche nel caso in cui le targhe siano state depositate (copertura del rischio fermo). I contratti di assicurazione FlexDrive che non includono un premio fisso vengono annullati nella data di deposito delle targhe.',
          },
          {
            headline: 'Recesso e conteggio:',
            text: "Se il contratto viene revocato da lei o da Simpego, sarà annullato nella data comunicata dal servizio della circolazione. Sulla carta di credito memorizzata nell'app autoSense verranno addebitati solo i chilometri percorsi fino all'annullamento del contratto e l'eventuale premio fisso proporzionalmente dovuto. Dopo un annullamento, l'importo massimo è sempre dovuto nei seguenti due casi: 1. Lei recede dal contratto in seguito a un danno parziale nel primo anno assicurativo e Simpego ha corrisposto la prestazione assicurativa per il danno; 2. Il contratto viene annullato in seguito a un danno totale (e quindi alla cessazione del rischio assicurato) e Simpego ha corrisposto la prestazione assicurativa per il danno. Dall'importo massimo vengono sottratti i premi già pagati per questo anno assicurativo. Per la richiesta dell'importo massimo dopo un annullamento le viene inviata una fattura. Questi importi non vengono addebitati sulla carta di credito.",
          },
          {
            headline: 'Scambio di dati autoSense - Simpego:',
            text: 'A partire dal momento in cui viene attivato il contratto si ha uno scambio di dati fra autoSense AG e Simpego Assicurazioni SA:',
          },
          {
            text: 'Simpego comunica ad autoSense: stato del contratto, copertura assicurativa, stato della copertura assicurativa, dati del veicolo assicurato, premio da addebitare per il mese precedente.',
          },
          {
            text: "autoSense comunica a Simpego: stato dell'adattatore (Disconnect / Connect), chilometri percorsi entro i confini della validità territoriale in conformità con le CCG, codice di transazione del pagamento.",
          },
          {
            text: "Fra Simpego e autoSense non vengono scambiate informazioni sul suo comportamento di guida, sulla sua ubicazione o sull'ubicazione del veicolo né informazioni correlate a sinistri.",
          },
        ],
        privacy: {
          part1: 'Ulteriori informazioni sulla protezione dei dati da parte di Simpego sono disponibili nella sezione «Protezione dei dati» delle nostre',
          part2: 'informazioni sul prodotto',
          part3: '.',
        },
      },
      kasko2go: {
        title: 'Condizioni particolari: kasko2go powered by Simpego',
        conditions: [
          {
            text: 'In caso di contraddizioni fra le condizioni generali di assicurazione (CGA) valide per il contratto e queste condizioni particolari (CP) si applicano le condizioni particolari.',
          },
          {
            headline: "Che cos'è kasko2go powered by Simpego",
            text: "Con kasko2go powered by Simpego una parte o l'intero premio del contratto di assicurazione è basato sul numero di chilometri che vengono percorsi con il veicolo assicurato e sul punteggio (votazione) calcolato da kasko2go per il suo comportamento di guida. L'eventuale premio fisso concordato è dovuto indipendentemente dai chilometri percorsi e dal punteggio di kasko2go.",
          },
          {
            headline: 'Importo annuale massimo',
            text: "Il premio annuale massimo dovuto (importo massimo) è stabilito nel contratto di assicurazione. Una volta raggiunto l'importo massimo, non verranno addebitati altri premi per il resto dell'anno assicurativo, a condizione che il contratto rimanga invariato.",
          },
          {
            headline: 'Pagamento del premio e conseguenze in caso di mancato pagamento',
            text: "Una volta al mese viene effettuato un addebito sulla carta di credito memorizzata nell'app kasko2go. Viene addebitato il premio per ogni chilometro percorso nel mese precedente e un dodicesimo dell'eventuale premio fisso per il mese successivo. L'importo addebitato include già le tasse e i contributi obbligatori. Se l'importo dovuto non può essere addebitato entro 10 giorni sulla carta di credito memorizzata nell'app kasko2go, Simpego ha il diritto di richiedere immediatamente l'importo massimo stabilito nel contratto. A tale proposito lei riceve una fattura. Dall'importo massimo vengono sottratti i premi già pagati per questo anno assicurativo. Se il contratto rimane invariato, per la restante durata del contratto non viene addebitato alcun altro premio, né conteggio chilometrico o punteggio di kasko2go.",
          },
          {
            headline: 'Richieste correlate a sinistri',
            text: 'Per franchigie e richieste di restituzione avanzate in relazione a sinistri, le inviamo una fattura. Questi importi non vengono addebitati sulla carta di credito.',
          },
          {
            headline: "Condizioni per l'utilizzo di kasko2go powered by Simpego e conseguenze in caso di violazione",
            text: "Per l'utilizzo di kasko2go powered by Simpego, lei si impegna a fare in modo che ogni distanza percorsa dal rispettivo conducente con il veicolo assicurato venga misurata con l'app kasko2go. A tale scopo è necessario che l'apparecchio sia acceso e l'app kasko2go sia attivata. Lei si impegna inoltre a dichiarare una volta al mese il chilometraggio del veicolo assicurato nell'app kasko2go. Simpego ha il diritto di richiederle in qualsiasi momento una foto del chilometraggio attuale. Se, nonostante ripetute richieste, lei non provvede a fornire una prova fotografica, Simpego ha il diritto di richiedere immediatamente l'importo massimo. Dall'importo massimo vengono sottratti i premi già pagati per questo anno assicurativo. Se il contratto rimane invariato, per la restante durata del contratto non viene addebitato alcun altro premio, né conteggio chilometrico o punteggio di kasko2Go.",
          },
          {
            headline: 'Differenze nel chilometraggio',
            text: "Nel caso vengano riscontrate differenze fra il chilometraggio da lei indicato tramite l'app kasko2go e i chilometri percorsi misurati dall'app kasko2go, Simpego ha il diritto di richiedere immediatamente l'importo massimo. Dall'importo massimo vengono sottratti i premi già pagati per questo anno assicurativo. Se il contratto rimane invariato, per la restante durata del contratto non viene addebitato alcun altro premio, né conteggio chilometrico o punteggio di kasko2go.",
          },
          {
            headline: 'Deposito delle targhe (sospensione)',
            text: 'I contratti di assicurazione kasko2go powered by Simpego che includono un premio fisso non variano quando le targhe vengono depositate presso il servizio della circolazione, ma il veicolo assicurato resta in suo possesso. Il premio fisso è dovuto anche nel caso in cui le targhe siano state depositate (copertura del rischio fermo). I contratti di assicurazione kasko2go powered by Simpego che non includono un premio fisso vengono annullati nella data di deposito delle targhe.',
          },
          {
            headline: 'Recesso e conteggio',
            text: "Se il contratto viene revocato da lei o da Simpego, sarà annullato nella data comunicata dal servizio della circolazione. Sulla carta di credito memorizzata nell'app kasko2go verranno addebitati solo i chilometri percorsi fino all'annullamento del contratto e l'eventuale premio fisso proporzionalmente dovuto. Dopo un annullamento, l'importo massimo è sempre dovuto nei seguenti due casi: 1. Lei recede dal contratto in seguito a un danno parziale nel primo anno assicurativo e Simpego ha corrisposto la prestazione assicurativa per il danno; 2. Il contratto viene annullato in seguito a un danno totale (e quindi alla conseguente cessazione del rischio assicurato) e Simpego ha corrisposto la prestazione assicurativa per il danno. Dall'importo massimo vengono sottratti i premi già pagati per questo anno assicurativo. Per la richiesta dell'importo massimo dopo un annullamento le viene inviata una fattura. Questi importi non vengono addebitati sulla carta di credito.",
          },
          {
            headline: 'Scambio di dati kasko2go - Simpego',
            text: 'A partire dal momento in cui viene attivato il contratto si ha uno scambio di dati fra kasko2go AG e Simpego Assicurazioni SA:',
          },
          {
            text: 'Simpego comunica a kasko2go lo stato del contratto, la copertura assicurativa, informazioni sui premi e dati correlati a sinistri del veicolo assicurato (data, tipo e dinamica del sinistro, importo).',
          },
          {
            text: "kasko2go comunica a Simpego i chilometri percorsi entro i confini della validità territoriale in conformità con le CCG, il codice di transazione del pagamento, il punteggio del comportamento di guida per ogni mese, tutti i dati raccolti ai fini della richiesta e dell'emissione del contratto relativi a contraente, conducente, veicolo assicurato e coperture assicurate.",
          },
          {
            text: "Fatta eccezione per il punteggio finale, fra Simpego e kasko2go non vengono scambiate informazioni sul suo comportamento di guida, né dati sulla sua ubicazione o sull'ubicazione del veicolo e nemmeno altri dati non menzionati qui.",
          },
        ],
        privacy: {
          part1: 'Ulteriori informazioni sulla protezione dei dati da parte di Simpego sono disponibili nella sezione «Protezione dei dati» delle nostre',
          part2: 'informazioni sul prodotto',
          part3: '.',
        },
      },
    },
  },
  offer: {
    headline: 'La sua offerta sta per arrivare!',
    text: "La ringraziamo del suo interesse nei confronti dell'assicurazione auto Simpego. Le abbiamo inviato l'offerta desiderata all'indirizzo e-mail da lei indicato. Controlli la sua casella di posta.",
    mailText: 'Se ha domande ci contatti pure',
  },
  confirmation: {
    headline: "Grazie per avere stipulato l'assicurazione. Un cordiale benvenuto nella famiglia Simpego!",
    headlineText: 'Per attivare la sua assicurazione auto ci servono ancora alcuni dati importanti:',
    form: {
      licencePlateAvailable: 'Ha già una targa per questo veicolo?',
      licencePlate: 'Qual è il numero di targa?',
      licencePlateActive: 'Questa targa è attualmente immatricolata o in circolazione?',
      vehicleRegisteredToOwner: 'Il veicolo {vehicleModel} è attualmente già immatricolato a nome di {policyholder}?',
      licencePlateRegisteredToOwner: 'Questa targa è attualmente immatricolata a nome di {policyholder}?',
      defaultPolicyholder: 'il contraente',
      registeredToDextra: 'È già stato assicurato presso Simpego con questo veicolo?',
      serialNumber: {
        text: 'Indichi il numero di matricola del veicolo da assicurare. Se non conosce il numero di matricola o al momento non lo ha a portata di mano, faccia clic sul pulsante «Registra informazioni in seguito». Le abbiamo già inviato una e-mail di conferma per la stipula della sua assicurazione, che contiene un link per accedere a questa pagina, dove in un secondo momento potrà inserire i dati mancanti.<br><br>Tenga presente che per emettere un certificato di assicurazione abbiamo assolutamente bisogno del numero di matricola corretto.',
        label: 'Numero di matricola',
      },
      btn: {
        submit: 'Ordina certificato di assicurazione',
        infoLater: 'Registra informazioni in seguito',
      },
      infoLaterPopup: 'Se desidera registrare le informazioni in un secondo momento, non c/’è problema. Le abbiamo già inviato una e-mail di conferma per la stipula della sua assicurazione;<br>Questa e-mail contiene un link a questa pagina. Facendo clic sul link può tornare qui in qualsiasi momento e fornire i dati mancanti.<br>Se ha domande ci contatti pure all/’indirizzo <a href="mailto:service@simpego.ch">service@simpego.ch</a>',
      inputTypeQuestions: 'Determina motivo immatricolazione',
      inputTypeDirect: 'Seleziona direttamente motivo immatricolazione',
    },
    ivReason: {
      label: 'Motivo immatricolazione',
      new: '57 - Nuova immatricolazione',
      reactivation: '52 - WIK A',
      vehicleChange: '58 - Cambio veicolo',
      ownerChange: '59 - Cambio proprietario',
      insurerChange: '54 - Cambio assicuratore',
      none: 'non occorre VNA',
    },
  },
  infoLater: {
    headline: 'Registra informazioni in seguito!',
    text: "Se desidera registrare le informazioni in un secondo momento, non c'è problema. Le abbiamo già inviato una e-mail di conferma per la stipula della sua assicurazione;<br>Questa e-mail contiene un link a questa pagina. Facendo clic sul link può tornare qui in qualsiasi momento e fornire i dati mancanti.",
    emailText: 'Se ha domande ci contatti pure',
    btn: 'Registra informazioni',
  },
  offerExpired: {
    headline: 'Purtroppo la sua offerta non è più valida.',
    text1: 'Se ha domande in merito, può rivolgersi al nostro team del Customer Solution Center che sarà lieto di assisterla per trovare la soluzione.',
    text2: 'Da Lun a Gio: ore 07.30 – 18.00 e Ven: ore 07.30 - 17.00 al numero: +41 58 521 11 11',
    mailText: 'Oppure tramite e-mail',
    text3: 'Può calcolare anche una nuova offerta:',
    newInsuranceRequest: 'Ricalcola il premio',
  },
  rejected: {
    headline: 'Nota',
    text1: 'La sua offerta è attualmente in fase di elaborazione, quindi il link nella sua e-mail non è più attivo. Se ha domande in merito, può rivolgersi al nostro team del Customer Solution Center che sarà lieto di assisterla per trovare la soluzione.',
  },
  finish: {
    headline: "Un cordiale benvenuto all'assicurazione auto migliore* della Svizzera!",
    text1: 'Grazie per i suoi dati. Come procediamo ora?',
    list1: 'Poiché ora abbiamo il suo numero di matricola, invieremo subito il certificato di assicurazione elettronico al servizio della circolazione di competenza. In seguito potrà immatricolare il veicolo.',
    list2: 'Non appena avrà immatricolato il veicolo, riceverà da noi i suoi documenti assicurativi e la fattura del premio.',
    hint: "*Ora l'abbiamo convinta.",
    homeButton: 'Alla pagina iniziale',
  },
  declined: {
    headline: 'Nota',
    text1: "Purtroppo al momento attuale non possiamo offrirle un'assicurazione per il suo veicolo.",
    text2: 'Confidiamo nella sua comprensione.',
    back: 'indietro',
    reason: 'Motivo:',
    defaultReason: 'Offerta non possibile',
  },
  renewalOfferings: {
    pageTitle: 'Le tue offerte di rinnovo',
    currentContract: 'Contratto attuale',
    proposal: 'Proposta',
    policyNumber: 'Contratto n. {number}',
    perYear: '/ Anno',
    yourData: 'I tuoi dati',
    name: 'Nome',
    birthdate: 'Data di nascita',
    email: 'E-mail',
    acceptProposal: 'Accetta proposta',
    ourRecommendation: 'Il nostro consiglio',
    ourRecommendationLine1: 'Il nostro',
    ourRecommendationLine2: 'consiglio',
    confirmAcceptText: 'Desidera accettare la proposta "{proposalTitle}" con un premio di CHF {premium} all\'anno?',
    offerExpired: 'Offerta scaduta',
    offerExpiredMessage: "L'offerta di rinnovo è purtroppo scaduta.",
    contactSupport: 'Per domande contatti il nostro servizio clienti.',
    noOffersAvailable: 'Nessuna offerta disponibile',
    alreadySelectedOrExpired: "È già stata selezionata un'offerta o le offerte sono scadute.",
    offerExpiredOrInvalid: "L'offerta è scaduta o non è valida.",
    deductiblePersonalEffects: 'Franchigia oggetti trasportati',
    replacementValueSupplement: 'Supplemento valore a nuovo',
    standStillRisk: 'Rischio di fermo',
    insuredPersons: 'Persone assicurate',
    insuredPersonsList: {
      3: 'tutti i passeggeri',
    },
    deathBenefit: 'Capitale in caso di decesso',
    disabilityCapital: 'Capitale invalidità',
    dailyCompensation: 'Indennità giornaliera dal 1° giorno',
    hospitalDailyCompensation: 'Indennità giornaliera ospedaliera',
    healingCosts: 'Spese di cura coperte',
    medicalExpenses: 'Spese di cura coperte',
    documentDispatch: 'Invio documenti',
    paymentFrequency: 'Frequenza di pagamento',
    electronic: 'elettronico',
    paper: 'cartaceo',
    yearly: 'annuale',
    halfYearly: 'semestrale',
    quarterly: 'trimestrale',
    monthly: 'mensile',
    yes: 'Sì',
    no: 'No',
    licensePlateDeposit: 'Deposito targa con rimborso del premio',
    error: 'Errore',
    errorOccurred: 'Si è verificato un errore. Si prega di riprovare.',
    technicalError: 'Si è verificato un errore tecnico. Si prega di riprovare più tardi.',
    ok: 'OK',
    cancel: 'Annulla',
    validUntil: 'Offerta valida fino al {date}',
    glassPlusWithSmallGlass: 'Vetro Plus (vetri piccoli)',
    glassBasis: 'Vetro Base',
    flexDrivePricing: 'Dettagli tariffa FlexDrive',
    capPremium: 'Premio massimo',
    fixPremiumKm: 'Premio fisso / km',
    totalPremiumKm: 'Premio totale / km',
    legalFees: 'Tasse legali',
    maxPerYear: 'max. {price}',
    success: {
      headline: 'Proposta accettata con successo!',
      message: 'Abbiamo ricevuto i tuoi dati, grazie mille!',
      nextStepsHeadline: 'Cosa succede dopo?',
      nextStepsText: 'Riceverà a breve una e-mail di conferma con tutti i dettagli\nIl suo contratto attuale verrà terminato automaticamente\nIl nuovo contratto entrerà in vigore il {date}\nIl nostro servizio clienti è a sua disposizione per qualsiasi domanda',
      backToHome: 'Torna alla pagina iniziale',
    },
  },
  errorPage: {
    headline: 'Nota',
    customerText: 'Si è verificato un errore. Contatti il servizio clienti.',
    agent: {
      text1: "L'apertura del suo funnel online personalizzato non ha funzionato.",
      text2: 'I motivi possono essere i seguenti:',
      text3: '- La pagina ha un problema tecnico.',
      text4: '- Il suo profilo di intermediario è ancora in attesa di essere attivato internamente da Simpego.',
      text5: '- Il suo profilo di intermediario è stato bloccato.',
      mail: 'Segnali questo errore al nostro Customer Solution Center tramite e-mail',
      tel: 'oppure telefonicamente al numero +41 58 521 11 11.',
      text6: 'Siamo raggiungibili da Lun a Gio: ore 07.30 – 18.00 e Ven: ore 07-30 - 17.00.',
    },
  },
  mediator: {
    mediatorData: "Dati dell'intermediario",
    mediatorName: 'Nome/azienda intermediario',
    mediatorID: 'ID intermediario',
    refreshWarning: 'Vuole avviare un nuovo calcolo? (I dati già registrati andranno persi!)',
    endSessionWarning: 'Vuole rimuovere la sua autenticazione di intermediario? (I dati già registrati andranno persi)',
  },
  servicePage: {
    headline: 'Abbiamo bisogno di fare un pit stop!',
    content: 'La pagina è in manutenzione.<br> Al momento non possiamo quindi fornire il calcolo del prezzo.<br> La preghiamo di riprovare in un secondo momento. Grazie! <br><br> Il team di Simpego',
  },
  validation: {
    messages: {
      required: 'Risponda a questa domanda.',
      validate_integer: 'Indichi un numero corretto.',
    },
    custom: {
      ownedSince: {
        required: "Selezioni l'anno in cui ha acquistato l'auto.",
      },
      businessUsage: {
        required: "Indichi se usa l'auto a scopi privati o lavorativi.",
      },
      canton: {
        required: "Selezioni il cantone in cui deve essere assicurata l'auto.",
      },
      leasing: {
        required: "Indichi se l'auto è in leasing.",
      },
      nationality: {
        required: 'Indichi la sua nazionalità.',
      },
      otherNationality: {
        required: 'Indichi la sua nazionalità.',
      },
      residencePermit: {
        required: 'Indichi il suo permesso di soggiorno.',
      },
      driverLicenceSinceYear: {
        required: "Indichi l'anno dal quale può guidare un'autovettura sulle strade.",
        min: "Indichi l'anno dal quale può guidare un'autovettura sulle strade.",
        between: 'Al momento della verifica il proprietario deve avere almeno 18 anni',
      },
      agentEmail: {
        required: 'Indichi la sua e-mail di intermediario.',
      },
      customerDocuments: {
        required: "Indichi l'invio di documenti.",
      },
      gender: {
        required: "Indichi l'appellativo.",
      },
      firstName: {
        required: 'Indichi il suo nome.',
      },
      lastName: {
        required: 'Indichi il suo cognome.',
      },
      street: {
        required: 'Indichi la sua via.',
      },
      houseNumber: {
        required: 'Indichi il suo numero civico.',
      },
      zip: {
        required: 'Indichi il suo NPA.',
        digits: 'Indichi un NPA a 4 cifre.',
        validate_zipcode: 'Indichi un NPA valido.',
      },
      city: {
        required: 'Indichi il suo domicilio.',
      },
      email: {
        required: 'Indichi la sua e-mail.',
        email: 'Indichi un indirizzo e-mail valido.',
        validate_email: 'Indichi un indirizzo e-mail valido.',
        umlaut_email: "L'indirizzo e-mail non è valido, non deve contenere ä, ö o ü.",
      },
      age: {
        required: 'Indichi la sua età.',
        validate_ageOrYear_16: "Indichi un'età compresa fra 16 e 99 anni.",
        validate_ageOrYear_18: "Indichi un'età compresa fra 18 e 99 anni.",
      },
      nationalitySwiss: {
        required: 'Indichi la sua nazionalità.',
      },
      phone: {
        required: "Avete scelto un modello di fatturazione con tracciamento (FlexDrive o BonusDrive). Inserite il numero di cellulare dello smartphone su cui desiderate installare l'app per monitorare il vostro comportamento alla guida.",
        validate_mobile_phone: 'Avete scelto un modello di fatturazione con tracciamento (FlexDrive o BonusDrive). Abbiamo bisogno del numero di cellulare dello smartphone su cui si desidera installare l\'app per tracciare il comportamento di guida. Il numero fornito non sembra essere un numero di cellulare (valido).',
        validate_phone: 'Si prega di controllare la propria iscrizione. Il numero di telefono deve avere una lunghezza compresa tra 8 e 13 cifre. Non è necessario inserire il numero.',
      },
      dateOfBirth: {
        required: 'Indichi la sua data di nascita.',
        date_format: 'Indichi la data nel seguente formato: GG.MM.AAAA',
        validate_ageMin: "Ha indicato la sua età al punto 1. Non può avere un'età inferiore a quella precedentemente indicata",
        validate_ageMax: "Ha indicato la sua età al punto 1. Non può avere un'età superiore rispetto a quella precedentemente indicata",
      },
      startOfInsurance: {
        required: "Indichi la data d'inizio dell'assicurazione.",
        after: 'La data da lei indicata si trova nel passato. Indichi una data attuale.',
        before: 'Indichi una data che rientri nei prossimi 12 mesi.',
        date_format: 'Indichi la data nel seguente formato: GG.MM.AAAA',
      },
      initialRegistrationYear: {
        required: "Indichi l'anno della prima immatricolazione.",
      },
      brand: {
        required: 'Selezioni innanzi tutto il marchio, quindi il modello.',
      },
      model: {
        required: 'Oltre al marchio selezioni anche il modello.',
      },
      typenumber: {
        required: 'Veicolo non trovato. Verificare i dati inseriti o usare la ricerca veicolo.',
        digits: 'Veicolo non trovato. Verificare i dati inseriti o usare la ricerca veicolo.',
      },
      typeCertificateNumber: {
        required: 'Indichi il certificato di omologazione.',
        regex: 'Verifichi il numero del certificato di omologazione (6 cifre)',
      },
      licencePlate: {
        required: 'Indichi il suo numero di targa.',
        digits: 'Verifichi la targa.',
        regex: 'Verifichi la targa.',
        between: 'Il numero di targa deve essere compreso fra 1 e 999999.',
      },
      partially_comprehensive: {
        park_damage_deductible: {
          max_value: 'La franchigia deve essere inferiore di almeno CHF 100 rispetto alla franchigia per collisione. In caso di franchigia per collisione di CHF 0 anche la franchigia per danni di parcheggio deve essere di CHF 0.',
        },
        personal_effects_coverage: {
          in: 'Sono consentiti solo CHF 0, CHF 1\´000, CHF 2\´000, CHF 3\´000, CHF 4\´000 oppure CHF 5\´000',
        },
        protective_clothing: {
          between: "Il valore dell'abbigliamento di protezione deve essere compreso fra CHF 0 (= non assicurato) e CHF 5\´000.",
        },
      },
      fully_comprehensive: {
        deductible1: {
          min_value: 'La franchigia deve essere superiore di almeno CHF 100 rispetto alla franchigia per collisione.',
          in: 'Indicare il valore a intervalli di 100.',
          between: 'In caso di copertura danni di parcheggio non assicurata, la franchigia deve essere compresa fra CHF 0 und CHF 10\´000.',
        },
        deductible2: {
          in: 'Indicare il valore a intervalli di 100.',
          between: 'In caso di copertura danni di parcheggio non assicurata, la franchigia deve essere compresa fra CHF 500 und CHF 10\´000.',
        },
      },
      legal: {
        required: 'Per continuare, confermi di avere preso atto dei documenti menzionati.',
      },
      legalAgent: {
        required: 'Per continuare, confermi che il cliente ha accettato i documenti e le condizioni validi per lui e la autorizza a stipulare questo contratto.',
      },
      serialNumber: {
        regex: 'Verifichi il formato',
        validate_serial_number: 'Verifichi che il numero di matricola da lei inserito non presenti errori.',
      },
      youngDriver: {
        validate_driverUnderTwentyfive: 'Lei ha indicato di avere meno di 25 anni, quindi non può rispondere no a questa domanda.',
      },
    },
  },
  rateListItems: {
    liability: 'Responsabilità civile',
    deductible: 'Franchigia CHF&nbsp;{value}',
    partially_comprehensive: 'Casco parziale',
    fully_comprehensive: 'Casco collisione',
    gross_negligence: 'Protezione per colpa&shy;grave',
    passenger_accident: 'Incidente <span>{bundle}</span>',
    '24_assistance': 'Assistenza 24 ore su 24 <span>{bundle}</span>',
    surcharges: 'Supplementi',
    daily_termination: 'Diritto di recesso giornaliero',
    deductiblePersonalEffects: 'Franchigia oggetti trasportati',
    replacementValueSupplement: 'Supplemento valore temporale',
    freeGarageChoice: 'Libera scelta del garage',
    standStillRisk: 'Rischio di fermo',
    Basis: 'Basis',
    Plus: 'Plus',
    Standard: 'Standard',
    not_covered: 'non assicurato',
    unlimited: 'senza limiti',
    yes: 'sì',
    no: 'no',
    versicherungssumme: 'Somma assicurata',
    protective_clothing: 'Abbigliamento di protezione',
    free_garage: {
      headline: 'Modello di riparazione: {value}',
      accordionText: '<p>{free_garage}</p>',
    },
    glass: {
      Basis: 'non assicurato',
      Plus: 'assicurato',
    },
    DexCarM: {
      liability: '<p>Somma assicurata:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;milioni</p><p>Franchigia per conducenti non dichiarati di età inferiore ai 25 anni:<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Vetro Plus (vetri piccoli):<br>{glas_package}</p><p>Effetti personali trasportati:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Danni di parcheggio:<br>{park_damage_value}</p><p>Franchigia copertura danni di parcheggio:<br>{park_damage_deductible}</p><p>Franchigia collisione per conducenti non dichiarati di età inferiore ai 25 anni:<br>+ CHF&nbsp;{value_under_25}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: 'Incidente standard',
      '24_assistance': 'Assistenza 24 ore su 24 Basis',
    },
    DexCarL: {
      liability: '<p>Somma assicurata:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;milioni</p><p>Franchigia per conducenti non dichiarati di età inferiore ai 25 anni:<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Vetro Plus (vetri piccoli):<br>{glas_package}</p><p>Effetti personali trasportati:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Danni di parcheggio:<br>{park_damage_value}</p><p>Franchigia copertura danni di parcheggio:<br>{park_damage_deductible}</p><p>Franchigia collisione per conducenti non dichiarati di età inferiore ai 25 anni:<br>+ CHF&nbsp;{value_under_25}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: '<p>Cerchia di persone:<br>Tutti i passeggeri</p><p>Decesso:<br>{death_benefit}</p><p>Invalidità:<br>{disability_capital}</p><p>Indennità giornaliera e ospedaliera:<br>&nbsp;{daily_compensation} al giorno</p>',
      '24_assistance': '<p>Rimorchio a:<br>officina più vicina</p><p>Viaggio di ritorno e mobilità<br> (ad es. auto sostitutiva/a noleggio)<br>fino a CHF&nbsp;1&#xFEFF;\´500</p>',
    },
    DexCarXl: {
      liability: '<p>Somma assicurata:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;milioni</p><p>Franchigia per conducenti non dichiarati di età inferiore ai 25 anni:<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Vetro Plus (vetri piccoli):<br>{glas_package}</p><p>Effetti personali trasportati:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Danni di parcheggio:<br>{park_damage_value}</p><p>Franchigia copertura danni di parcheggio:<br>{park_damage_deductible}</p><p>Franchigia collisione per conducenti non dichiarati di età inferiore ai 25 anni:<br>+ CHF&nbsp;{value_under_25}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: '<p>Cerchia di persone:<br>Tutti i passeggeri</p><p>Decesso:<br>{death_benefit}</p><p>Invalidità:<br>{disability_capital}</p><p>Indennità giornaliera e ospedaliera:<br>&nbsp;{daily_compensation} al giorno</p>',
      '24_assistance': '<p>Rimorchio a:<br>officina a scelta</p><p>Viaggio di ritorno e mobilità<br> (auto sostitutiva/a noleggio)<br>fino a CHF 4&#xFEFF;\´000</p>',
    },
    flexDrive: {
      headline: 'FlexDrive',
      accordionText: 'Fatturazione al chilometro esatto in base ai chilometri effettivamente percorsi. La scelta tra i modelli di fatturazione può essere effettuata nelle pagine seguenti “modifica coperture” o al punto 3 in base ai dati del proprietario. Si prega di notare che a ogni numero di cellulare può essere associato un solo contratto FlexDrive.',
    },
  },
  billingModels: {
    flex_drive: 'FlexDrive',
    flat_rate: 'BasisDrive',
    bonus_drive: 'BonusDrive',
  },
  billingModelChooser: {
    trackingDrivingBehaviour: 'Monitoraggio del comportamento di guida',
    chooseBillingModel: 'Selezionare il modello di fatturazione',
    bonusDriveExplanation: '(BasisDrive con tracciamento del vostro comportamento di guida)',
    headlineInfoText: {
      flex_drive: "<p>Il premio totale è composto da un premio fisso (rischi fissi (casco parziale)) e da un premio variabile (rischi mobili (collisione, responsabilità civile, colpa grave)). Il premio totale (CAP) ha un massimale (premio annuo massimo garantito).</p><br><p>Come si calcola il CAP? Premio fisso annuo + premio chilometrico per 12.000 chilometri. FlexDrive viene fatturata mensilmente con carta di credito.</p><br><p>I chilometri percorsi al mese per anno assicurativo e il punteggio (comportamento di guida) vengono comunicati tramite l'app. Il punteggio può ridurre ma non aumentare il premio chilometrico.</p><br><p>Appena emessa la polizza, riceverete un SMS e un'EMAIL con le istruzioni per scaricare l'app e registrarsi. Per simpego FlexDrive è necessaria un'app simpego FlexDrive attivata. Non appena si consente all'app di monitorare i propri viaggi, essa funziona in background. Non è necessario riavviare l'app o fare qualcosa di speciale ogni volta che si parte.</p> <p>Si prega di notare che a ogni numero di cellulare può essere associato un solo contratto FlexDrive</p>",
      bonus_drive: "<p>Non appena il vostro contratto sarà stato regolato, riceverete un SMS e un'EMAIL con le istruzioni per scaricare l'APP e registrarvi.</p><br><p>L'APP simpego FlexDrive funzionerà in background per monitorare la vostra guida. Occasionalmente si possono ricevere messaggi che ricordano di tenere acceso il Wi-Fi o di riavviare l'applicazione se smette di funzionare per qualsiasi motivo. Il punteggio della corsa verrà visualizzato dopo aver completato le prime 10 corse (vedere la mappa Trip Tracker nell'app). È possibile visualizzare l'elenco dei viaggi precedenti. In base alle prestazioni di guida, il punteggio verrà aggiornato e visualizzato nella schermata principale dell'app. In questo modo ci faremo un'idea di che tipo di guidatore siete, vi aiuteremo a migliorare e vi faremo ottenere uno sconto sull'assicurazione.</p> <p>Si prega di notare che a ogni numero di cellulare può essere associato un solo contratto BonusDrive</p>",
    },
    subline: {
      flex_drive: "FlexDrive è un sistema di fatturazione basato sul chilometraggio, in cui si pagano solo i chilometri effettivamente percorsi. Il premio totale è composto da un <a href=\"https://www.simpego.ch/flexdrive-it\" target=\"blank\">premio fisso annuale</a>, da un <a href=\"https://www.simpego.ch/flexdrive-it\" target=\"blank\">premio variabile</a> (premio per chilometro) e dal <a href=\"https://www.simpego.ch/flexdrive-it\" target=\"blank\">comportamento di guida</a>. Il comportamento alla guida viene monitorato tramite un' app e convertito in un punteggio. Questo può ridurre, ma non aumentare, il premio effettivo da pagare per chilometro.  Si prega di notare che a ogni numero di cellulare può essere associato un solo contratto FlexDrive.",
      flat_rate: "Il premio è fissato per anno contrattuale e deve essere pagato in anticipo. L'importo dipende dai rischi assicurati e dalle prestazioni concordate.",
      bonus_drive: "Il premio è fissato per anno contrattuale e deve essere pagato in anticipo. L'importo dipende dai rischi assicurati e dalle prestazioni concordate. Durante l'anno assicurativo è possibile conoscere il proprio bonus e ricevere uno sconto sull'assicurazione per l'anno assicurativo successivo. Per registrare il tuo comportamento di guida nell’app Simpego e calcolare il tuo bonus, abbiamo bisogno del tuo numero di cellulare. Si prega di notare che a ogni numero di cellulare può essere associato un solo contratto BonusDrive.",
    },
    trackingDrivingBehaviourInfoText: "<p>Il monitoraggio del comportamento di guida fa parte di FlexDrive e BonusDrive.</p><br><p>Per tracciare il vostro comportamento di guida è necessaria l'applicazione Simpego FlexDrive. Dopo la firma del contratto, riceverete un SMS e un'EMAIL con le istruzioni per scaricare l'app e registrarvi. Non appena l'app è autorizzata a monitorare i viaggi, viene eseguita in background. Non è necessario riavviare l'app ogni volta o fare qualcosa di particolare prima di partire. Dopo la registrazione nell'app, riceverete tutte le ulteriori informazioni via e-mail.</p>",
  },
  productInfoText: {
    DexCarM: 'Il nostro premio per i risparmiatori. Tutto ciò di cui avete bisogno come automobilisti: Responsabilità civile, casco parziale e collisione.',
    DexCarL: "Il nostro prodotto più popolare. Approfittate di prestazioni superiori alla media a premi vantaggiosi, tra cui l'assicurazione contro gli infortuni, la colpa grave e l'assistenza 24 ore su 24.",
    DexCarXl: "Il consiglio dell'insider sul mercato. Il nostro prodotto per tutti coloro che apprezzano una copertura illimitata con una franchigia minima. Le migliori condizioni per la responsabilità civile, il casco parziale, la copertura collisione, l'assicurazione infortuni, la colpa grave e l'assistenza 24 ore su 24.",
    billingModelInfo: "È possibile scegliere tra il modello di fatturazione BasisDrive, FlexDrive o BasisDrive con tracciamento del vostro comportamento di guida. FlexDrive è una fatturazione basata sui chilometri, in cui si pagano solo i chilometri effettivamente percorsi. Se l'auto è parcheggiata in garage o si viaggia meno, si risparmia automaticamente sul premio. E grazie alla fatturazione mensile, avrete sempre una visione d'insieme! BonusDrive e FlexDrive non sono ancora disponibili per le moto e i clienti aziendali. <a href=\"https://blog.simpego.ch/it/modelli-di-fatturazione-assicurazione-auto/\" target=\"blank\">Ulteriori informazioni sono disponibili qui</a>",
  },
  file: {
    select: 'Selezionare il file',
    clear: 'Cancella il campo di immissione',
  },
}
